import { action, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import './sign-up.css';
import InputField from '../../common/forms/input-field'
import PageFrameSingleForm from '../../common/page-frames/single-form'
import SignUpConfirmation from './SignUpConfirmation';
import SignUpMentor from './SignUpMentor';
import strings from '../../strings';

import { SignUpProps, UserType } from '../../types';

@inject('signUpStore')
@observer
class SignUp extends React.Component<SignUpProps> {
  constructor(props: SignUpProps) {
    super(props);
  }

  public componentWillMount() {
    const { match, signUpStore } = this.props;
    // Determine user type; default to 'mentee' if not specified
    const paramUserType = match.params.userType;
    const isMentor: boolean = !!paramUserType && paramUserType.toLowerCase() === UserType.MENTOR;
    if (isMentor) {
      signUpStore!.userType = UserType.MENTOR;
    }
  }

  public render() {
    if (this.props.signUpStore!.userType === UserType.MENTOR) {
      return <SignUpMentor {...this.props} />;
    }

    const store = this.props.signUpStore!;
    if (store.signUpSucceeded) {
      return <SignUpConfirmation />;
    }

    const formAdditionalInfo = (
      <span>
        Already have an account?&nbsp;
        <a href="/sign-in" className="link has-text-primary">Log in.</a>
      </span>
    );

    return (
      <PageFrameSingleForm
          additionalInfo={formAdditionalInfo}
          className="sign-up"
          formTitle={strings.texts.CREATE_NEW_ACCOUNT}
          path="sign-up"
          title={strings.texts.CREATE_NEW_ACCOUNT}
      >
        <InputField
            disabled={store.awaitServer}
            helpMessage={store.firstNameHelpMessage}
            highlight={store.firstNameHighlight}
            layoutClassName="column is-6 is-marginless"
            name="firstName"
            onBlur={this.handleFirstNameBlur}
            onChange={this.handleFirstNameChange}
            placeholder={strings.texts.FIRST_NAME}
            type="text"
            value={store.firstName}
        />

        <InputField
            disabled={store.awaitServer}
            helpMessage={store.lastNameHelpMessage}
            highlight={store.lastNameHighlight}
            layoutClassName="column is-6 is-marginless"
            name="lastName"
            onBlur={this.handleLastNameBlur}
            onChange={this.handleLastNameChange}
            placeholder={strings.texts.LAST_NAME}
            type="text"
            value={store.lastName}
        />

        <InputField
            disabled={store.awaitServer}
            helpMessage={store.emailHelpMessage}
            highlight={store.emailHighlight}
            layoutClassName="column is-12 is-marginless"
            name="email"
            onBlur={this.handleEmailBlur}
            onChange={this.handleEmailChange}
            placeholder={strings.texts.EMAIL}
            type="text"
            value={store.email}
        />

        <InputField
            disabled={store.awaitServer}
            helpMessage={store.passwordHelpMessage}
            highlight={store.passwordHighlight}
            layoutClassName="column is-12 is-marginless"
            name="password"
            onBlur={this.handlePasswordBlur}
            onChange={this.handlePasswordChange}
            placeholder={strings.texts.PASSWORD}
            type="password"
            value={store.password}
        />

        <InputField
            disabled={store.awaitServer}
            helpMessage={store.confirmHelpMessage}
            highlight={store.confirmHighlight}
            layoutClassName="column is-12 is-marginless"
            name="confirm"
            onBlur={this.handleConfirmBlur}
            onChange={this.handleConfirmChange}
            placeholder={strings.texts.CONFIRM_PASSWORD}
            type="password"
            value={store.confirm}
        />

        <div className="column is-12 field is-marginless">
          <button
              className={`button is-primary ${store.awaitServer ? 'is-loading' : ''}`}
              disabled={store.awaitServer}
              onClick={this.handleSubmit}
              type="submit">
            {strings.texts.CREATE_NEW_ACCOUNT}
          </button>
          <p id="sign-up-agreement" className="help has-text-grey">{strings.texts.AGREEMENT_STATEMENT}</p>
        </div>
      </PageFrameSingleForm>
    );
  }

  /**
   * Handles submit action; disables all form controls.
   */
  @action
  private handleSubmit = async () => {
    const store = this.props.signUpStore!;
    store.confirmBlurred = true;
    store.emailBlurred = true;
    store.firstNameBlurred = true;
    store.lastNameBlurred = true;
    store.passwordBlurred = true;

    if (store.isReadyForSubmit){
      try {
        await store.signUp();
        runInAction(() => store.signUpSucceeded = true);
      } catch (error) {
        runInAction(() => {
          store.signUpFailed = true;
          store.awaitServer = false;
        });
      }
    }
  };

  @action
  private handleConfirmChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.confirm = event.currentTarget.value;
  }

  @action
  private handleConfirmBlur = () => {
    this.props.signUpStore!.confirmBlurred = true;
  }

  @action
  private handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.email = event.currentTarget.value;
  }

  @action
  private handleEmailBlur = () => {
    this.props.signUpStore!.emailBlurred = true;
  }

  @action
  private handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.firstName = event.currentTarget.value;
  }

  @action
  private handleFirstNameBlur = () => {
    this.props.signUpStore!.firstNameBlurred = true;
  }

  @action
  private handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.lastName = event.currentTarget.value;
  }

  @action
  private handleLastNameBlur = () => {
    this.props.signUpStore!.lastNameBlurred = true;
  }

  @action
  private handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.password = event.currentTarget.value;
  }

  @action
  private handlePasswordBlur = () => {
    this.props.signUpStore!.passwordBlurred = true;
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/pages/sign-up/SignUp.tsx